import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './GeneralInfoForm.css';

const GradeForm = ({ gradeId, initialData, onSuccess }) => {
    const baseUrl = process.env.REACT_APP_BASE_URL;
  const [gradeName, setGradeName] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  // ✅ Fill form if initialData is provided (edit mode)
  useEffect(() => {
    if (initialData && initialData.grade) {
      setGradeName(initialData.grade);
    }
  }, [initialData]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!gradeName.trim()) {
      setError('Grade name is required');
      return;
    }

    setLoading(true);
    setError('');

    try {
      let url = '';
      let method = 'POST';
      let body = {};

      if (gradeId) {
        // ✅ Edit mode
        url = `${baseUrl}/updateGradeById/${gradeId}`;
        body = { grade: gradeName };
      } else {
        // ✅ Create mode
        url = `${baseUrl}/createGrade`;
        body = { grade: gradeName };
      }

      const response = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });

      const data = await response.json();

      if (data.status) {
        alert(gradeId ? 'Grade updated successfully' : 'Grade created successfully');
        if (onSuccess) onSuccess();
        navigate('/grade');
      } else {
        setError(data.message || `Failed to ${gradeId ? 'update' : 'create'} PYAGROUP`);
      }
    } catch (err) {
      setError('Error connecting to server');
    } finally {
      setLoading(false);
    }
  };

  return (
    <form className="general-info-form" onSubmit={handleSubmit}>
      <h2 className="section-title">{gradeId ? 'Edit Grade' : 'Add Grade'}</h2>
      <div className="form-grid">
        <div className="form-floating">
          <input
            type="text"
            className="form-control"
            id="gradeName"
            placeholder=" "
            autoComplete="off"
            value={gradeName}
            onChange={(e) => setGradeName(e.target.value)}
            disabled={loading}
          />
          <label htmlFor="gradeName">Grade Name</label>
        </div>
      </div>
      {error && <p style={{ color: 'red', marginTop: '8px' }}>{error}</p>}
      <button
        type="submit"
        className="btn btn-primary"
        style={{ marginTop: '15px' }}
        disabled={loading}
      >
        {loading ? 'Saving...' : 'Save'}
      </button>
    </form>
  );
};

export default GradeForm;
